/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */

import React, { useEffect, useState, useRef } from 'react';
import { CommonDropdown, RegularButton, CommonInput } from 'pg-ui-library';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { TooltipBoxTable, Loader } from 'pg-ui-library';

import { Container, ScreenHeader, CardHeader, LeftHeader, RightHeader, PageTitle } from './styles';
import { myticketOptions } from '../personal-info/index';
import { useQuery } from '@tanstack/react-query';
import SupportDeskService from 'src/services/support-desk.service';
import { DataGrid, GridCellParams, GridColDef } from '@mui/x-data-grid';
import { Chip } from '@mui/material';
import { CellSpan } from './styles';

const SupportDesk: React.FC = () => {
  const navigate = useNavigate();
  const validationSchema = yup.object({
    subject: yup.string().max(255).required(),
  });

  const statusMapping: Record<
    string,
    { color: 'default' | 'primary' | 'secondary' | 'error' | 'success'; label: string; bgColor: string }
  > = {
    cancelled: { color: 'default', label: 'Cancelled', bgColor: '#d32f2f' },
    Cancelled: { color: 'default', label: 'Cancelled', bgColor: '#d32f2f' },

    open: { color: 'default', label: 'Open', bgColor: '#1976d2' },
    Open: { color: 'default', label: 'Open', bgColor: '#1976d2' },

    inProgress: { color: 'default', label: 'In Progress', bgColor: '#0288d1' },
    InProgress: { color: 'default', label: 'In Progress', bgColor: '#0288d1' },
    'In Progress': { color: 'default', label: 'In Progress', bgColor: '#0288d1' },

    onHold: { color: 'default', label: 'On Hold', bgColor: '#ffa000' },
    OnHold: { color: 'default', label: 'On Hold', bgColor: '#ffa000' },
    'On Hold': { color: 'default', label: 'On Hold', bgColor: '#ffa000' },

    solved: { color: 'default', label: 'Solved', bgColor: '#388e3c' },
    resolved: { color: 'default', label: 'Solved', bgColor: '#388e3c' },
    Resolved: { color: 'default', label: 'Solved', bgColor: '#388e3c' },
  };

  const ticketDetail = (ticket: any) => {
    console.log('params', ticket);
    navigate(`/ticket-detail/${ticket.id}`);
  };

  const supportTicketTableColumns: GridColDef[] = [
    {
      headerName: 'ID',
      headerClassName: 'CommonHeaderClass',
      field: 'supportNumber',
      minWidth: 150,
      renderCell: params => (
        <CellSpan title={params.value} data-tag="allowRowEvents" onClick={() => ticketDetail(params.row)}>
          {params.value}
        </CellSpan>
      ),
    },
    {
      headerName: 'Module',
      headerClassName: 'CommonHeaderClass',
      field: 'module',
      minWidth: 150,
      sortable: true,
      filterable: false,
      renderCell: params => {
        const rawValue = params.value;
        const module = typeof rawValue === 'string' ? rawValue.toLowerCase() : '';
        let label = '';

        if (module === 'hrprofile' || module === 'hr_profile') {
          label = 'Profile';
        } else if (module === 'benefits') {
          label = 'Benefit';
        } else if (module === 'pay_history' || module === 'payroll') {
          label = 'Payroll';
        } else if (module === 'tax' || module === 'tax_forms') {
          label = 'Tax forms';
        } else {
          label = rawValue ?? ''; // fallback to empty string if null/undefined
        }

        return (
          <CellSpan title={label} data-tag="allowRowEvents">
            {label}
          </CellSpan>
        );
      },
    },
    {
      headerName: 'Subject',
      headerClassName: 'CommonHeaderClass',
      field: 'subject',
      minWidth: 180,
      renderCell: params => (
        <CellSpan title={params.value} data-tag="allowRowEvents">
          {params.value}
        </CellSpan>
      ),
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Sub Category',
      headerClassName: 'CommonHeaderClass',
      field: 'subCategory',
      minWidth: 150,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Description',
      headerClassName: 'CommonHeaderClass',
      field: 'description',
      minWidth: 180,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Priority',
      headerClassName: 'CommonHeaderClass',
      field: 'priority',
      minWidth: 120,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Attachments',
      headerClassName: 'CommonHeaderClass',
      field: 'attachments',
      minWidth: 180,
      renderCell: params => {
        const attachments = params.value as { attachmentName?: string }[];
        if (attachments && attachments.length > 0) {
          return (
            <CellSpan title={attachments[0].attachmentName} data-tag="allowRowEvents">
              {attachments[0].attachmentName}
            </CellSpan>
          );
        }
        return <CellSpan>No Attachments</CellSpan>;
      },
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Status',
      field: 'status',
      width: 150,
      renderCell: params => {
        const status = params.value as string;
        const { color, label, bgColor } = statusMapping[status] || {
          color: 'default',
          label: 'Unknown',
          bgColor: '#9e9e9e',
        };
        return (
          <Chip
            label={label}
            variant="outlined"
            style={{
              backgroundColor: bgColor,
              font: '16px',
              color: 'white',
              borderColor: 'transparent',
              textTransform: 'capitalize',
              fontWeight: 'bold',
            }}
          />
        );
      },
    },
  ];

  const formik = useFormik({
    initialValues: {
      moduleCategory: '',
      subCatergory: '',
      subject: '',
      description: '',
      priority: '',
      attachments: '',
      searchQuery: '',
      ticketCategory: '',
    },
    validationSchema,
    onSubmit: async (values: any) => {
      try {
        console.log('Form Submitted:', values);
      } catch (error) {
        console.error('Error during form submission', error);
      }
    },
  });

  const idTicketPage = () => {
    navigate('/id-ticket');
  };

  const createTicketPage = () => {
    navigate('/create-ticket');
  };

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const [sortBy, setSortBy] = useState('');
  const [searchTerm, setsearchTerm] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [status, setStatus] = useState('');
  const companyId = '';
  const tableWrapperRef = useRef<HTMLDivElement>(null);

  const { isFetching, data } = useQuery(
    ['support-desk', paginationModel.page, paginationModel.pageSize, searchTerm, sortBy, sortDirection, status],
    async () => {
      return await SupportDeskService.getSupportTickets({
        companyId,
        page: paginationModel.page + 1, // API is 1-based
        limit: paginationModel.pageSize,
        search: searchTerm,
        sortBy,
        sortDirection,
        status,
      });
    }
  );

  const onSortMetaChange = async (changes: any) => {
    setSortBy(changes[0].field as unknown as string);
    setSortDirection(changes[0].sort);
  };

  const formattedData = data?.items?.map((row, index) => ({
    ...row,
    id: row.id || index + 1,
  }));

  return (
    <Container>
      <ScreenHeader>
        <PageTitle>Support Desk - My Tickets</PageTitle>

        <RightHeader style={{ display: 'flex', alignItems: 'center' }}>
          <CommonInput
            id="searchQuery"
            name="searchQuery"
            placeholder="Search..."
            value={formik.values.searchQuery}
            onChange={event => {
              formik.setFieldValue('searchQuery', event.target.value);
              setsearchTerm(event.target.value);
            }}
            style={{
              width: '200px',
              marginRight: '10px',
              backgroundColor: 'white',
              color: 'black',
              border: '1px solid #ccc',
              borderRadius: '4px',
              padding: '5px',
            }}
            label={''}
          />

          <CommonDropdown
            label=""
            id="ticketCategory"
            name="ticketCategory"
            options={myticketOptions}
            value={formik.values.ticketCategory}
            setValue={(value: string) => {
              console.log('value', value);
              formik.setFieldValue('ticketCategory', value);
              const newStatus = value === 'All Tickets' ? '' : value;
              setStatus(newStatus);
            }}
            selectStyle={{
              width: '200px',
              marginRight: '10px',
              backgroundColor: 'white',
              color: 'black',
              border: '1px solid #ccc',
              borderRadius: '4px',
            }}
          />

          <RegularButton onClick={createTicketPage}>New Ticket</RegularButton>
        </RightHeader>
      </ScreenHeader>
      <CardHeader>
        <LeftHeader></LeftHeader>
      </CardHeader>

      <div
        ref={tableWrapperRef}
        style={{
          width: '100%',
          overflow: 'auto',
        }}
      >
        {formattedData && formattedData.length > 0 ? (
          <DataGrid
            key={paginationModel.pageSize}
            rows={formattedData ?? []}
            columns={supportTicketTableColumns}
            pagination
            paginationMode="server"
            sortingMode="server"
            loading={isFetching}
            rowCount={data?.meta?.totalItems ?? 0}
            pageSizeOptions={[10, 20, 50]}
            paginationModel={paginationModel}
            onPaginationModelChange={model => {
              if (model.pageSize !== paginationModel.pageSize) {
                setPaginationModel({
                  page: 0,
                  pageSize: model.pageSize,
                });
              } else {
                setPaginationModel(model);
              }
            }}
            onSortModelChange={onSortMetaChange}
            disableColumnFilter
            sx={{
              font: '14px Biotif',
              fontWeight: 'bold',
              '& .CommonHeaderClass': {
                color: '#9399B2',
                font: '16px Biotif',
                fontWeight: 'bold',
              },
              minHeight: '150px',
            }}
          />
        ) : (
          <div style={{ minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            No support tickets to display. If you need assistance, you can create a new ticket by clicking "New Ticket."
          </div>
        )}
      </div>
    </Container>
  );
};

export default SupportDesk;
